<script setup lang="ts">
import EmDashPlaceholder from '@/components/placeholders/EmDashPlaceholder.vue';

export interface Item {
  name: string;
  value?: string | number | undefined;
}

export interface Props {
  items?: Item[];
}
const props = withDefaults(defineProps<Props>(), {
  items: () => [],
});
</script>

<template>
  <dl
    :class="$style.dailyReportCardJobsDescList"
    data-testid="dailyReportCardJobsDescList"
  >
    <div v-for="item in props.items" :key="item.name" :class="$style.item">
      <dt>
        {{ item.name }}
      </dt>
      <dd>
        <EmDashPlaceholder :item="item.value" />
      </dd>
    </div>
  </dl>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/variables';

.dailyReportCardJobsDescList {
  margin: 0;
}
  .item {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;

    dd {
      margin: 0;
    }
  }

  .item:last-child {
    margin-bottom: 0;
  }
</style>
